import React from "react";
import { Printer } from "lucide-react";
import { toast } from "sonner";

/**
 * Triggers the browser's native print dialog, which lets the user save as PDF.
 * Print CSS in index.css hides nav, footer, comments, buttons, etc.
 */
export default function PrintButton({ label = "Export PDF", testId = "print-pdf-btn" }) {
  const onClick = () => {
    try {
      toast.info("Use 'Save as PDF' in your browser print dialog");
      setTimeout(() => window.print(), 250);
    } catch {
      toast.error("Print not supported in this browser");
    }
  };

  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className="inline-flex items-center gap-2 px-3 py-1.5 border border-white/15 text-zinc-400 hover:text-white hover:border-white/30 font-mono text-[10px] tracking-[0.2em] uppercase transition-colors no-print"
    >
      <Printer size={12} /> {label}
    </button>
  );
}
